<template>
  <div class="doc-content">
    <section class="doc-header">
      <h1>Cerrar Sesión</h1>
      <p class="lead">
        Mientras el usuario permanezca con sesión iniciada en el sistema, puede finalizar su actividad de forma segura
        mediante la opción de cierre de sesión.
      </p>
    </section>

    <plataformaNavegacion @cambio-plataforma="actualizarVista" />

    <hr />
    <div v-if="plataforma === 'web'" class="platform-content">
      <section class="doc-section">
        <h2>Procedimiento de Salida</h2>
        <p>Para cerrar la sesión actual, siga estos pasos:</p>
        <ol class="step-list">
          <li>
            Hacer clic sobre el nombre o el icono de perfil para desplegar las opciones.
          </li>
          <li>
            Dar clic en el botón <strong>Cerrar sesión</strong>.
          </li>
        </ol>
      </section>

      <section v-if="imagenesLogout.length > 0">
        <CarruselAciqui :items="imagenesLogout" />
      </section>

      <section class="doc-note">
        <div class="alert-warning">
          <p>
            <strong>Importante:</strong> Se recomienda cerrar la sesión siempre que termine su jornada o cuando se aleje
            de su dispositivo para garantizar la seguridad de los datos del sistema.
          </p>
        </div>
      </section>
    </div>

    <div v-if="plataforma === 'moviles'" class="platform-content">
      <section class="doc-section">
        <h2>Procedimiento de Salida</h2>
        <p>Para cerrar la sesión actual, siga estos pasos:</p>
        <ol class="step-list">
          <li>
            Hacer clic sobre el nombre o el icono de perfil para desplegar las opciones.
          </li>
          <li>
            Dar clic en el botón <strong>Cerrar sesión</strong>.
          </li>
        </ol>
      </section>

      <section v-if="imagenesLogoutMoviles.length > 0">
        <CarruselAciqui :items="imagenesLogoutMoviles" />
      </section>

      <section class="doc-note">
        <div class="alert-warning">
          <p>
            <strong>Importante:</strong> Se recomienda cerrar la sesión siempre que termine su jornada o cuando se aleje
            de su dispositivo para garantizar la seguridad de los datos del sistema.
          </p>
        </div>
      </section>
    </div>

  </div>
</template>

<script>
// Importamos el carrusel (ajusta la ruta según tu estructura de carpetas)
import CarruselAciqui from './Carruselimg.vue';
import plataformaNavegacion from './BotonesNavegacion.vue';

export default {
  name: 'CierreSesionDoc',
  components: {
    CarruselAciqui,
    plataformaNavegacion
  },
  data() {
    return {
      plataforma: 'web',
      // Agrega aquí las rutas de las imágenes cuando las tengas
      imagenesLogout: [
        {
          nombre: "Cierre de sesión",
          url: "img/manejo_sesion/cierre_sesion.png",
          descripcion: ""
        }
      ],
      imagenesLogoutMoviles: [
        {
          nombre: "Cierre de sesión",
          url: "img/Inicio_sesion/cerrar_sesion_movil.png",
          descripcion: ""
        }
      ]
    }
  },
  methods: {
    actualizarVista(val) {
      this.plataforma = val;
    }
  }
}
</script>

<style scoped>
/* Estilos coherentes con LoginDoc.vue */
.doc-content {
  line-height: 1.6;
  color: inherit;
}

h1 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: #3b82f6;
}

h2 {
  font-size: 1.5rem;
  margin-top: 2rem;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3rem;
}

h3 {
  font-size: 1.1rem;
  margin-top: 1.5rem;
  color: #666;
}

.lead {
  font-size: 1.1rem;
  color: #6a737d;
  margin-bottom: 1rem;
}

.step-list {
  padding-left: 2rem;
  margin-bottom: 1.5rem;
}

.step-list li {
  margin-bottom: 1rem;
}

.figure-caption {
  text-align: center;
  font-size: 0.9rem;
  color: #586069;
  margin-top: 10px;
  font-weight: bold;
}

.alert-warning {
  background-color: #fff9db;
  /* Color amarillento suave para advertencia */
  border-left: 0.25em solid #f59e0b;
  padding: 1rem;
  margin-top: 2rem;
  border-radius: 3px;
  color: #856404;
}

.carrusel-container {
  margin: 20px 0;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}
</style>